import { Action } from 'vuex'
import { RootState } from '@/store/types'
import { MediaLibraryState } from '../types'
import { MediaLibraryImage } from '@/types/mediaLibrary'
import SiriusAPI from '@/api'
import uniqCid from '@/helpers/uniqCid'
import { getImageType } from '@/helpers/getImageType'
import { checkHEIC } from '@/helpers/checkHEIC'

const addImageMediaLibrary: Action<MediaLibraryState, RootState> = async (
  { commit },
  { essence, essenceId, image_id, image_file }: MediaLibraryImage
) => {
  const requestId = uniqCid()
  commit('setPendingRequests', { essence, requestId })

  try {
    const { item } = await SiriusAPI.mediaLibrary.addImageMediaLibrary({
      essenceId: essenceId,
      essence: essence,
      image_id: image_id,
    })

    if (image_file && !checkHEIC(image_file) && item.image) {
      const imageUrl = URL.createObjectURL(image_file)
      item.image_type = getImageType(item.image.url)
      item.preview = imageUrl
    }

    commit('setImageMediaLibrary', {
      essence,
      image: Object.freeze(item),
    })
  } catch (error) {
    console.error(error)
  } finally {
    commit('deletePendingRequests', { essence, requestId })
  }
}

export default addImageMediaLibrary
